import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, } from 'react';
const SessionContext = createContext(null);
export function SessionProvider({ children, session = getSession() }) {
    return _jsx(SessionContext.Provider, { value: session, children: children });
}
export function useSession() {
    const session = useContext(SessionContext);
    if (!session) {
        throw new Error('The useSession hook must be used within a SessionProvider.');
    }
    return session;
}
export function withSessionProvider(WrappedComponent) {
    return function WithSessionComponent(props) {
        return (_jsx(SessionProvider, { children: _jsx(WrappedComponent, { ...props }) }));
    };
}
export function getSession() {
    return globalThis.window?.__dashboardSession;
}
